import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

// OBTENER INVENTARIO - SCREEN
export const getInventarioSuministros = async () => {
  const respuesta = await PrivateInterceptor(`Inventario/InventarioProductos`, "GET");
  return respuesta;
};

// OBTENER PRODUCTOS MAS CONSUMIDOS - DASHBOARD
export const getProductosMasConsumidos = async (IdCalendario) =>{
  const result = await PrivateInterceptor(`Inventario/InventarioProductos/ProductosMasConsumido`, 'POST',  {IdCalendario} );
  return result;
}

// OBTENER PRODUCTOS DE MAYOR CONSUMO - DASHBOARD
export const getProductosDeMayorConsumo = async (IdCalendario) =>{
  const result = await PrivateInterceptor(`Inventario/InventarioProductos/ProductosDeMayorConsumo`, 'POST',  {IdCalendario} );
  return result;
}

export const getInventarioCHistorico = async (MesCierre, AnioCierre) => {
  const result = await PrivateInterceptor(`Inventario/InventarioProductos/historico`, 'POST', {MesCierre :MesCierre, AnioCierre: AnioCierre});
  return result;
} 

export const getMesCierre = async (IdReferencia) => { 
  const result = await PrivateInterceptor(`Inventario/InventarioProductos/MesCierre/${IdReferencia}`, 'GET');
  return result;
}

export const generarCierre = (IdUserCerro) => {
  const respuesta = PrivateInterceptor("Inventario/InventarioProductos/GenerarCierre", "POST", {IdUserCerro});
  return respuesta;
};

export const generarExcelCierre = () => {
  const respuesta = PrivateInterceptor("Inventario/InventarioProductos/GenerarExcelCierre", "GET");
  return respuesta;
};


//----------------------------------------- MATERIA PRIMA --------------------------------------------------

export const getInventarioMateriaPrima = async () => {
  const respuesta = await PrivateInterceptor(`Inventario/InventarioMateriaPrima`, "GET");
  return respuesta;
};

export const getHistoricoMP = async (MesCierre, AnioCierre) => {
  const result = await PrivateInterceptor(`Inventario/InventarioMateriaPrima/historico`, 'POST', {MesCierre :MesCierre, AnioCierre: AnioCierre});
  return result;
} 

export const generarCierreMP = (IdUserCerro) => {
  const respuesta = PrivateInterceptor("Inventario/InventarioMateriaPrima/GenerarCierre", "POST", {IdUserCerro});
  return respuesta;
};

export const generarExcelCierreMP = () => {
  const respuesta = PrivateInterceptor("Inventario/InventarioMateriaPrima/GenerarExcelCierre", "GET");
  return respuesta;
};

export const getTomaInventario = async (IdMes, Anio, IdTipoIngreso) => { 
  const result = await PrivateInterceptor(`Scanner/BodegaSuministros/InventarioMesAnio/${IdMes}/${Anio}/${IdTipoIngreso}`, 'GET');
  return result;
}

export const getTomaInventarioFechas = async(dates) =>{
  const result = await PrivateInterceptor(`Scanner/BodegaSuministros/TomaInventarioBodega`, 'POST',{FechaInicio: dates?.Fecha1, FechaFinal: dates?.Fecha2})
  return result
}

export const getTomaInventarioMPFechas = async(dates) =>{
  const result = await PrivateInterceptor(`Scanner/BodegaSuministros/TomaInventarioMP`, 'POST',{FechaInicio: dates?.Fecha1, FechaFinal: dates?.Fecha2})
  return result
}

export const eliminarTomaInv = (datos) => {
  const respuesta = PrivateInterceptor("Scanner/BodegaSuministros/EliminarInventarioProducto", "POST", {datos});
  return respuesta;
};

export const getTomaInventarioReporte = async(date, IdReferencia) =>{
  const result = await PrivateInterceptor(`Scanner/BodegaSuministros/TomaInventarioReporte`, 'POST', {FechaReporte: date, IdReferencia: IdReferencia})
  return result
}